import { usePostRender } from '../../../composables'
import { GaProductCardFavorite } from '../../molecules/favorite'

import { useBehavior } from './scripts/composables'

// @vue/component
export default {
  name: 'ga-product-card-favorite-adapter',

  components: {
    GaProductCardFavorite,
  },

  props: {
    /** Продукт */
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  emits: ['click-add-to-favorite', 'add-to-favorite'],

  setup(props, { attrs, emit }) {
    const { data } = toRefs(props)

    const { onFavoriteClick } = useBehavior(emit)

    const dataFavorite = computed(() => {
      const { itemId, name, favourite } = unref(data) || {}

      return { name, itemId, favourite }
    })

    const propsToPass = computed(() => {
      const { data, ...restProps } = attrs
      return restProps
    })

    const { postRendered } = usePostRender()

    return { onFavoriteClick, dataFavorite, propsToPass, postRendered }
  },
}
